export default __webpack_public_path__ + "static/media/visitlogo.781ef67f.png";